import React, { useEffect, useState } from 'react'
import {rootContexts} from './rootContexts'
export default function RootContextProvider({children}) {
    const [asLogin,setAsLogin]= useState(false)
    const [audioResult,setAudioResult]= useState(false)
    const [asLoginSuccess,setAsLoginSuccess]= useState(false)
    const [asLoading,setAsLoading]= useState(true)
    
    const token= localStorage.getItem('token')
    useEffect(()=>{
      if(token){
        setAsLoginSuccess(true)
      }
      else{
        setAsLoginSuccess(false)
      }
    },[token])
  return (
    <rootContexts.Provider value={{asLogin,setAsLogin,audioResult,setAudioResult,asLoginSuccess,setAsLoginSuccess,asLoading, setAsLoading}}>
        {children}
    </rootContexts.Provider>
  )
}
